import React, { createContext, useReducer } from "react";
import EmployeesReducer from "../reducers/employees.reducer";
import { employeesColumns } from "../../statics/columns";
import moment from "moment";

const initialState: any = {
  mode: 'table',
  employees: [],
  employeesCache: [],
  employeesPaginated: [],
  filters: [],
  activeFilters: [],
  currentEmployee: {},
  chartLabels: [],
  workingHours: [],
  tasks: [],
  reviews: [],
  rate: 0,
  activities: {
    labels: [],
    colors: [],
    data: []
  },
  buildings: [],
  columns: employeesColumns,
  activeFilter: 'currentWeek',
  activeRange: {
    from: moment().startOf('isoWeek').format('YYYY-MM-DD'),
    to: moment().endOf('isoWeek').format('YYYY-MM-DD')
  },
  options: {
    withExport: true,
    withPrint: true,
    withRefresh: true,
    withSort: true,
    withSearch: true,
    withSwitch:true,
    sortDirection: 'asc',
    sortColumn: 'name',
    searchString: '',
    searchColumn: 'name'
  },
  pagination: {
    currentPage: 1,
    items: 10,
    totalPages: 1
  }
};

export const EmployeesContext = createContext(initialState);
export const EmployeesProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(EmployeesReducer, initialState);

  function setWorkingHours(workingHours: any) {
    dispatch({
      type: "SET_WORKING_HOURS",
      payload: { workingHours }
    });
  }

  function setReviews(reviews: any[]) {
    dispatch({
      type: "SET_REVIEWS",
      payload: { reviews }
    });
  }

  function setRate(rate: number) {
    dispatch({
      type: "SET_RATE",
      payload: { rate }
    });
  }

  function setViewMode(mode: string) {
    dispatch({
      type: "SET_VIEW_MODE",
      payload: { mode }
    });
  }

  function setActivities(activities: any) {
    dispatch({
      type: "SET_ACTIVITIES",
      payload: { activities }
    });
  }

  function setEmployees(employees: any[]) {
    dispatch({
      type: "SET_EMPLOYEES",
      payload: { employees }
    });
  }

  function setChartLabels(labels: any) {
    dispatch({
      type: "SET_CHARTS_LABELS",
      payload: { labels }
    });
  }

  function setBuildings(buildings: any[]) {
    dispatch({
      type: "SET_BUILDINGS",
      payload: { buildings }
    });
  }

  function setChartFilter(activeFilter: string) {
    dispatch({
      type: "SET_CHARTS_FILTER",
      payload: { activeFilter }
    });
  }

  function setCurrentEmployee(employee: any) {
    dispatch({
      type: "SET__CURRENT_EMPLOYEE",
      payload: { employee }
    });
  }

  function setFilters(filters: any[]) {
    dispatch({
      type: "SET_FILTERS",
      payload: { filters }
    });
  }

  function setActiveFilter(filter: string) {
    dispatch({
      type: "SET_ACTIVE_FILTERS",
      payload: { filter }
    });
  }

  function setTasks(tasks: any) {
    dispatch({
      type: "SET_TASKS",
      payload: { tasks }
    });
  }

  function clearActiveFilters(filter: string) {
    dispatch({
      type: "CLEAR_ACTIVE_FILTERS",
      payload: { }
    });
  }

  function sort(params: any) {
    dispatch({
      type: "SORT_EMPLOYEES",
      payload: { params }
    });
  }

  function search(params: any) {
    dispatch({
      type: "SEARCH_EMPLOYEES",
      payload: { params }
    });
  }

  function paginate(params: any) {
    dispatch({
      type: "PAGINATE_EMPLOYEES",
      payload: { params }
    });
  }


  return (
    <EmployeesContext.Provider
      value={{
        ...state,
        setTasks,
        setActivities,
        setCurrentEmployee,
        setChartLabels,
        setEmployees,
        setActiveFilter,
        clearActiveFilters,
        setChartFilter,
        setViewMode,
        setWorkingHours,
        setBuildings,
        setFilters,
        setRate,
        setReviews,
        search,
        sort,
        paginate
      }}
    >
      { children }
    </EmployeesContext.Provider>
  );
};